<template lang="pug">
  b-modal#deliveries-massive-set-partner-modal(ref="modal" title="Externalizar envíos" @hidden="clear")
    input.d-none(ref="inputFile" type="file" name="file" @change="loadFile")
    .loading(v-if="loading")
      .text-center.mb-2 {{ loadingText }}
      b-spinner.m-auto
    
    //- Cargar archivo
    div(v-else-if="step===1")
      div.text-left
        ul
          li Descarga la plantilla de carga masiva
            |  
            a(href="/PlantillaCargaPartner.xlsx" target="_blank" download style="color: blue") aquí
          li El archivo debe contar con las siguientes columnas: CÓDIGO, PARTNER y PARTNER TAG
          li La columna PARTNER puede tener los siguientes valores:
            ul
              li FAZT
              li 12 HORAS
              li STGO COURIER
              li Dejar en blanco
      .text-center
        b-button(@click="() => this.$refs.inputFile.click()" style="display: inline-flex; align-items: center;") Cargar archivo
          .material-icons upload

    //- Seleccionar hojas
    div(v-else-if="step===2")
      .mb-2 Se encontraron varias paginas, selecciona las que deseas ingresar y has click en Siguente
      b-form-checkbox-group(v-model="sheets" :options="sheetsOptions" stacked)
      b-button(@click="step=3") Siguente
    
    //- Resultados
    div(v-else-if="step===3")
      div(v-if="validationErrors.length > 0")
        div ERRORES:
        ul
          li(v-for="error in validationErrors" :key="error") {{ error }}
        .text-center
          b-button(@click="step=1" style="display: inline-flex; align-items: center;") Volver
           .material-icons upload
      div(v-else-if="deliveries.length > 1") Se cargaron correctamente {{deliveries.length}} envíos para ser asignados
      div(v-else-if="deliveries.length === 1") Se cargó correctamente {{deliveries.length}} envío para ser asignado
      div(v-else-if="deliveries.length === 0" @click="step=1") No se encontraron envíos para ser asignados en este archivo, haz click aquí para reintentar

    template(#modal-footer)
      b-button(@click="close()" variant="outline-primary") Cancelar
      b-button(v-if="step===3" @click="onSubmit") Asignar Partner
</template>

<script>
import xlsxFile from 'read-excel-file'
import { mapActions, mapGetters } from 'vuex'
import partnerUtils from '@/utils/partnerUtils'
export default {
  data () {
    return {
      loadingText: 'Cargando archivo',
      validationErrors: [],
      step: 1,
      file: null,
      sheets: [],
      sheetsOptions: [],
      loading: false,
      deliveries: [],
      errorCount: 0,
      schema: {
        PARTNER: {
          prop: 'partnerCode',
          type: String,
          required: true
        },
        CÓDIGO: {
          prop: 'id',
          type: String,
          required: true
        },
        'PARTNER TAG': {
          prop: 'partnerTag',
          type: String,
          required: false
        }
      }
    }
  },
  methods: {
    ...mapActions(['massiveSetPartner', 'validateDeliveriesIds']),
    clear () {
      this.step = 1
      this.file = null
      this.sheets = []
      this.sheetsOptions = []
      this.loading = false
      this.deliveries = []
      this.errorCount = 0
    },
    close () {
      this.$refs.modal.hide()
      this.clear()
    },
    formatPartnerCode (partnerCode) {
      return partnerCode.toLowerCase().trim()
    },
    formatTag (tag) {
      return tag.toLowerCase().trim().replace('í', 'i').replace('ó', 'o').replace('á', 'a').replace('é', 'e')
    },
    formatId (id) {
      if (Number.isInteger(id)) {
        return id
      }
      return parseInt(id.trim())
    },
    async validate (data) {
      const errors = []
      const unknownPartners = []
      const unknownTags = []
      const partnerCodes = [partnerUtils.partners.DOCE_HORAS_ENVIOS, partnerUtils.partners.FAZT, partnerUtils.partners.STGO_COURIER]
      const tags = ['flex', 'cambio', 'devolucion']
      
      for (const delivery of data) {
        if (delivery.partnerCode && !partnerCodes.includes(this.formatPartnerCode(delivery.partnerCode))) {
          unknownPartners.push(delivery.partnerCode)
        }
        if (delivery.partnerTag && !tags.includes(this.formatTag(delivery.partnerTag))) {
          unknownTags.push(delivery.partnerTag)
        }
      }

      const response = await this.validateDeliveriesIds({ ids: data.map(d => d.id) })
      const notFoundIds = response.data.notFoundIds

      if (notFoundIds.length > 0) {
        errors.push('Los siguientes envíos no se encontraron: ' + notFoundIds.join(', '))
      }

      if (unknownPartners.length > 0) {
        errors.push('Se encontraron partners no validos: ' + unknownPartners.join(', ') + '. \nLos valores validos son: ' + partnerCodes.join(', '))
      }
      if (unknownTags.length > 0) {
        errors.push('Se encontraron tags no validos: ' + unknownTags.join(', ') + '. \nLos valores validos son: ' + tags.join(', '))
      }

      this.validationErrors = errors

      return errors.length === 0
    },
    async onSubmit () {
      this.loading = true
      try {
        if (!this.validate(this.deliveries)) {
          this.loading = false
          return
        }
        this.loadingText = 'Asignando partner'
        await this.massiveSetPartner({ data: this.deliveries })

        this.$root.$bvToast.toast('Los envíos se actualizaron correctamente', {
          title: 'Éxito',
          variant: 'success',
        })
        this.close()
      } catch (error) {
        this.$root.$bvToast.toast('Error al actualizar los envíos', {
          title: 'Error',
          variant: 'danger',
        })
      } finally {
        this.loading = false
      }
    },
    async loadFile (event) {
      this.file = event.target.files[0]
      this.loading = true
      const sheets = await xlsxFile(this.file, { getSheets: true })
      this.sheetsOptions = sheets.reduce((acum, item) => acum.concat({
        value: item.name,
        text: item.name
      }), [])

      if (this.sheetsOptions.length === 1) {
        this.sheets = [this.sheetsOptions[0].value]
        this.step = 3
      } else {
        this.step = 2
      }
      this.loading = false
      this.$refs.inputFile.value = null
    },
    async step3Validation () {
      this.loading = true
      this.loadingText = 'Validando datos'
      
      let deliveries = []
      let count = 0
      for (const sheet of this.sheets) {
        const { rows } = await xlsxFile(this.file, { schema: this.schema, sheet })
        deliveries = deliveries.concat(rows.map((d) => {
          return {
            id: this.formatId(d.id),
            partnerCode: d.partnerCode ? this.formatPartnerCode(d.partnerCode) : null,
            partnerTag: d.partnerTag ? this.formatTag(d.partnerTag) : null
          }
        }))
        count++
      }
      this.deliveries = deliveries
      this.validate(deliveries)
      this.loading = false
    }
  },
  watch: {
    async step () {
      if (this.step === 2 && this.sheetsOptions.length === 1) {
        this.sheets = [this.sheetsOptions[0].value]
        this.step = 3
      }
      if (this.step === 3) {
        this.step3Validation()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#upload-deliveries-from-exel {
  .loading {
    display: flex;
    justify-content: center;
    height: 200px;
    flex-direction: column;
  }
}
</style>
